import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from 'react';
import { TOURIST_SERVICE_TYPE_ICON } from '../../shared/constants';
import { GeneralConfigContext } from '../general-config-provider';
import styles from '../../styles/molecules/offer-type-label.module.scss';
import Icon from './icon';
import {
  getTouristServiceTypeName,
  getTouristServiceTypeNameEn,
} from '../../shared/utils';
import { useRouter } from 'next/router';

type OfferTypeLabelProps = {
  offerTypeID: number;
};

export const OfferTypeLabel: FunctionComponent<OfferTypeLabelProps> = ({
  offerTypeID,
}) => {
  const { generalConfig } = useContext(GeneralConfigContext);
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);

  useEffect(() => {
    if (router.locale) {
      setLocale(router?.locale);
    }
  }, [router?.locale]);
  return (
    <div className={styles.offerTypeLabel}>
      <Icon icon={TOURIST_SERVICE_TYPE_ICON[offerTypeID]} size={18} />
      <p>
        {locale === 'en'
          ? getTouristServiceTypeNameEn(
              offerTypeID,
              generalConfig?.tipo_servicio_turistico
            )
          : getTouristServiceTypeName(
              offerTypeID,
              generalConfig?.tipo_servicio_turistico
            )}
      </p>
    </div>
  );
};
